import { render } from "./GenderSelector.vue?vue&type=template&id=29826cd2&scoped=true"
import script from "./GenderSelector.vue?vue&type=script&lang=js"
export * from "./GenderSelector.vue?vue&type=script&lang=js"

import "./GenderSelector.vue?vue&type=style&index=0&id=29826cd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29826cd2"]])

export default __exports__